<!-- TabList.svelte -->
<script lang="ts">
	import { getContext } from 'svelte'
	import type { TabContext } from '$lib/stores/tab-context'
	interface Props {
		children?: import('svelte').Snippet;
		[key: string]: any
	}

	let { ...props }: Props = $props();

	const { selected } = getContext<TabContext>('tabs')
</script>

<div {...props} role="tablist" class={props.class}>
	{@render props.children?.()}
</div>
